import BulkPermissionsCsvDashboard from './dashboard';
export default BulkPermissionsCsvDashboard;
